import { Toggle } from './Toggle'
import { withToggle } from './withToggle'

const ConnectedToggle = withToggle(Toggle)

export { ConnectedToggle as Toggle }
